import PlanejamentoAlojamento from "./pages/PlanejamentoAlojamento";
import DetalhePlanejamentoAlojamento from "./pages/DetalhePlanejamentoAlojamento";
import PreAlojamento from "./components/DetalhePlanejamentoAlojamento/PreAlojamento";
import Creches from "./components/DetalhePlanejamentoAlojamento/Creches";
import Disponibilidade from "./components/DetalhePlanejamentoAlojamento/Disponibilidade";
import Alojamento from "./components/DetalhePlanejamentoAlojamento/Alojamento";

export default [
	{
		path: '/planejamentoAlojamento/',
		name: 'planejamentoAlojamento',
		component: PlanejamentoAlojamento
	},
	{
		path: '/planejamentoAlojamento/:id/',
		name: 'detalhePlanejamentoAlojamento',
		component: DetalhePlanejamentoAlojamento,
		children: [
			{
				path: 'alojamento',
				name: 'alojamento',
				component: Alojamento
			},
			{
				path: 'disponibilidade',
				name: 'disponibilidade',
				component: Disponibilidade
			},
			{
				path: 'creches',
				name: 'creches',
				component: Creches
			},
			{
				path: 'preAlojamento',
				name: 'preAlojamento',
				component: PreAlojamento
			},
		]
	},
];
